import angular from 'angular';
import LinkTypeService from './linkType.service.js';
import LinkTypeSchema from './linkType.schema';

let linkTypeModule = angular.module('linkType', [])

    .service('LinkTypeService', LinkTypeService)
    .constant('LinkTypeSchema', LinkTypeSchema)
    .name;

export default linkTypeModule;
